export default {
  name: 'maInfoBox',
  props: {
    title: { type: String, default: '' },
    description: { type: String, default: '' }
  }
}
